export default function DashboardStats({ stats }) {
  const { productos, pagos, gastos, loading } = stats; // <-- cambiamos facturas por pagos

  if (loading) return <p>Cargando métricas…</p>;

  return (
    <>
      <div className="dashboard-item">
        <span>Productos</span>
        <strong>{productos}</strong>
      </div>
      <div className="dashboard-item">
        <span>Ingresos Mes</span>
        <strong>
          {typeof pagos === "number"
            ? new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP" }).format(pagos)
            : pagos}
        </strong>
      </div>
      <div className="dashboard-item">
        <span>Gastos Mes</span>
        <strong>
          {typeof gastos === "number"
            ? new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP" }).format(gastos)
            : gastos}
        </strong>
      </div>
    </>
  );
}
